import { tw } from "~/utils";

interface ToggleProps {
  checked: boolean;
  onChange: () => void;
  disabled?: boolean;
}

export const Toggle = ({
  checked,
  onChange,
  disabled = false,
}: ToggleProps) => {
  return (
    <button
      type="button"
      onClick={onChange}
      disabled={disabled}
      className={tw(
        "relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-150 ease-in-out focus:outline-none focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2",
        checked ? "bg-indigo-600" : "bg-gray-200",
        disabled && "cursor-not-allowed opacity-50",
      )}
    >
      <span className="sr-only">Test user toggle</span>
      <span
        className={tw(
          "pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-150 ease-out",
          checked ? "translate-x-5" : "translate-x-0",
        )}
      />
    </button>
  );
};
